/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { useLocalization } from '@/data/Localization';
import { AddressFormActionLabels } from '@/data/types/Address';
import { Stack } from '@mui/material';
import { FC } from 'react';

type Props = {
	onCancel?: () => void;
	submitLabel: AddressFormActionLabels;
	cancelLabel?: AddressFormActionLabels;
	submitting?: boolean;
	editPerson?: boolean;
	hasPrimaryAdd?: boolean;
};
export const AddressFormActions: FC<Props> = ({
	onCancel,
	submitLabel,
	cancelLabel,
	submitting,
	editPerson,
	hasPrimaryAdd,
}) => {
	const addressFormNLS = useLocalization('AddressForm');
	return (
		<Stack direction={{ xs: 'column', sm: 'row' }} spacing="15px">
			{onCancel ? (
				<DpButton
					sx={{ width: { xs: '100%', md: '50%' } }}
					id="address-form-cancel"
					data-testid="address-form-cancel"
					variant="unfocused"
					onClick={onCancel}
					disabled={hasPrimaryAdd}
				>
					{cancelLabel ? addressFormNLS.Actions[cancelLabel].t() : null}
				</DpButton>
			) : null}

			<DpButton
				sx={{ width: { xs: '100%', md: '50%' } }}
				id="address-form-save"
				data-testid="address-form-save"
				type="submit"
				disabled={submitting}
			>
				{submitLabel
					? editPerson
						? 'Guardar contacto'
						: submitLabel === 'CreateAddress'
						? 'Guardar dirección'
						: addressFormNLS.Actions[submitLabel].t()
					: null}
			</DpButton>
		</Stack>
	);
};
